
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from './use-toast';

export const useDeleteRoyaltyReport = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (reportId: string) => {
      const { error } = await supabase
        .from('royalty_reports')
        .delete()
        .eq('id', reportId);
      
      if (error) {
        toast({
          title: 'Error deleting royalty report',
          description: error.message,
          variant: 'destructive',
        });
        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['royaltyReports'] });
      toast({
        title: 'Success',
        description: 'Royalty report has been deleted.',
      });
    }
  });
};
